import {
    Badge,
    Box,
    Button,
    Divider,
    IconButton,
    List,
    ListItemButton,
    ListItemText,
    Menu,
    Typography,
} from "@mui/material";
import { useState } from "react";
import { FaBell } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useNotifications } from "../../../../contexts/NotificationsProvider";

export default function NotificationsBell({ iconColor = "common.white", size = 18 }) {
    const navigate = useNavigate();
    const { items, unreadCount, markAsRead, markAllAsRead, refreshNotifications } = useNotifications();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
        refreshNotifications();
    };

    const handleClose = () => setAnchorEl(null);

    const handleClickItem = async (item) => {
        if (!item.is_read) {
            await markAsRead(item.id);
        }
        handleClose();
        if (item.link) {
            navigate(item.link);
        }
    };

    return (
        <>
            <IconButton
                onClick={handleOpen}
                aria-label="Notificações"
                aria-controls={open ? "store-notifications-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                sx={{
                    color: iconColor,
                    p: 1,
                    "&:hover": {
                        color: "secondary.main",
                        bgcolor: "transparent",
                    },
                }}
            >
                <Badge
                    badgeContent={unreadCount}
                    sx={{
                        "& .MuiBadge-badge": {
                            bgcolor: "secondary.main",
                            color: "primary.main",
                            fontWeight: 700,
                            fontSize: 10,
                        },
                    }}
                >
                    <FaBell size={size} />
                </Badge>
            </IconButton>

            <Menu
                id="store-notifications-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{
                    sx: {
                        width: 360,
                        maxWidth: "92vw",
                        mt: 1,
                        border: "1px solid",
                        borderColor: "divider",
                    },
                }}
            >
                <Box
                    sx={{
                        px: 2,
                        py: 1.25,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 1,
                    }}
                >
                    <Typography sx={{ fontWeight: 700, fontSize: 14 }}>Notificações</Typography>
                    {unreadCount > 0 && (
                        <Button
                            size="small"
                            onClick={markAllAsRead}
                            sx={{ textTransform: "none", color: "secondary.main", fontWeight: 600 }}
                        >
                            Marcar todas
                        </Button>
                    )}
                </Box>
                <Divider />
                {items.length === 0 ? (
                    <Box sx={{ px: 2, py: 3 }}>
                        <Typography sx={{ fontSize: 13, color: "text.secondary", textAlign: "center" }}>
                            Nenhuma notificação por enquanto.
                        </Typography>
                    </Box>
                ) : (
                    <List dense disablePadding sx={{ maxHeight: 380, overflowY: "auto" }}>
                        {items.map((item) => (
                            <ListItemButton
                                key={item.id}
                                onClick={() => handleClickItem(item)}
                                sx={{
                                    alignItems: "flex-start",
                                    bgcolor: item.is_read ? "transparent" : "rgba(200,164,89,0.12)",
                                    borderBottom: "1px solid",
                                    borderColor: "divider",
                                    py: 1.25,
                                }}
                            >
                                <ListItemText
                                    primary={
                                        <Typography
                                            sx={{
                                                fontSize: 13,
                                                fontWeight: item.is_read ? 500 : 700,
                                            }}
                                        >
                                            {item.title}
                                        </Typography>
                                    }
                                    secondary={
                                        <>
                                            {item.body && (
                                                <Typography
                                                    component="span"
                                                    sx={{ display: "block", fontSize: 12, color: "text.secondary", mt: 0.25 }}
                                                >
                                                    {item.body}
                                                </Typography>
                                            )}
                                            <Typography
                                                component="span"
                                                sx={{ display: "block", fontSize: 11, color: "text.disabled", mt: 0.5 }}
                                            >
                                                {item.created_at_fmt || item.created_at}
                                            </Typography>
                                        </>
                                    }
                                />
                            </ListItemButton>
                        ))}
                    </List>
                )}
            </Menu>
        </>
    );
}
